import {UyapRequest} from "./UyapRequest";

export interface KisiSorgulaError {
    errorCode: string;
    message: string;
}

export const KisiSorgulaErrorMessages = {
    INVALID_TC: {
        errorCode: 'INVALID_TC',
        message: 'Geçersiz T.C. Kimlik Numarası. Lütfen 11 haneli geçerli bir T.C. Kimlik Numarası giriniz.'
    },
    TC_NOT_FOUND: {
        errorCode: 'TC_NOT_FOUND',
        message: 'T.C. Kimlik Numarası bulunamadı. Lütfen bilgilerinizi kontrol ediniz.'
    },
    // TODO: errorCode ile eslestirilecek. "Sunucudan anlamli veri alinamadi"
    UYAP_CONNECTION_ERROR: {
        errorCode: 'PRTL_GNL_10001-55',
        message: 'Uyap kaynakli bağlantı hatası. Lütfen daha sonra tekrar deneyiniz.'
    },
    AUTHORIZATION_ERROR: {
        errorCode: 'AUTHORIZATION_ERROR',
        message: 'Bu işlem için yetkiniz bulunmamaktadır.'
    },
    SESSION_EXPIRED: {
        errorCode: 'SESSION_EXPIRED',
        message: 'Oturumunuzun süresi dolmuş. Lütfen tekrar giriş yapınız.'
    },
    SYSTEM_MAINTENANCE: {
        errorCode: 'SYSTEM_MAINTENANCE',
        message: 'Sistem bakımda. Lütfen daha sonra tekrar deneyiniz.'
    },
    RATE_LIMIT_EXCEEDED: {
        errorCode: 'RATE_LIMIT_EXCEEDED',
        message: 'Çok fazla sorgu gönderildi. Lütfen bir süre bekleyip tekrar deneyiniz.'
    },
    UNKNOWN_ERROR: {
        errorCode: 'UNKNOWN_ERROR',
        message: 'Uyap kaynaklı sorgu yapılamadı, tekrar deneyiniz.'
    }
} as const;

export interface KisiSorgulaTalep {
    tcKimlikNo: string
}

export interface KisiSorgulaCevap {
    olumKaydi: boolean,
    isAvukat: boolean,
    isNoter: boolean,
    isTarafUyari: boolean,
    isHakimSavci: boolean,
    mernisDegisiklikVarmi: boolean,
    mernisDegisiklikNedeni: string,
    sorguTuru: number,
    kisiKurumID: number,
    tcKimlikNo: string,
    adi: string,
    soyadi: string,
    babaAdi: string,
    anaAdi: string,
    dogumTarihiStr: string,
    cinsiyeti: string,
    aktifMernisAdresiSorgusu: boolean,
    hasOlumKaydi: boolean
}

export default class KisiSorgula extends UyapRequest<KisiSorgulaTalep, KisiSorgulaCevap> {
    delayTime = 1000;

    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "kisi_" + this.talepData.tcKimlikNo
        };
    }

    getMockResponse(): any {
        return {"olumKaydi":false,"isAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","sorguTuru":0,"kisiKurumID":144140118,"tcKimlikNo":"57490126802","adi":"ÖM**","soyadi":"ŞE*","babaAdi":"SÜ******","anaAdi":"YI****","dogumTarihiStr":"*2/*3/1991","cinsiyeti":"E","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false};
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'kisiSorgula.ajx';
    }

    async parse(data: any): Promise<KisiSorgulaCevap> {
        if (data && typeof data === 'object' && data.error) {
            throw new Error('Uyap kaynaklı sorgu yapılamadı, tekrar deneyiniz.');
        }

        if (!data || typeof data !== 'object') {
            throw new Error('Uyap kaynaklı sorgu yapılamadı, tekrar deneyiniz.');
        }

        return data;
    }

}
